"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitSideEffects = exports.initSplit = exports.initAvailableClients = exports.initSplitClient = void 0;
const either_1 = require("../../types/either");
const splitio_1 = require("@splitsoftware/splitio");
const browser_1 = require("../../helpers/browser");
const log_1 = require("../../helpers/log");
const constants_1 = require("./constants");
const util_1 = require("util");
const validators_1 = require("./validators");
const helpers_1 = require("./helpers");
const newrelic_1 = require("./newrelic");
// -------------------- Init Clients ------------------------------------
// Generic module for traffic type independant split client initialization
const initSplitClient = (trafficType, key) => __awaiter(void 0, void 0, void 0, function* () {
  (0, log_1.debugLog)(`Initializing Split for traffic type: ${trafficType} with key: ${key}`);
  const windowKey = (0, helpers_1.getWindowKeyForTrafficType)(trafficType);
  const factory = (0, splitio_1.SplitFactory)({
    core: {
      authorizationKey: constants_1.SPLIT_IO_AUTH_KEY,
      key,
      trafficType
    }
  });
  const client = factory.client();
  return new Promise(resolve => {
    client.on(client.Event.SDK_READY, () => {
      // Will log with ?debugLog=true param
      (0, log_1.debugLog)(`Split client has initialized for traffic type: ${trafficType} with key: ${key}`);
      // DANGER MUST BE FIXED
      // Some madness going on here assigning arbitrary variables to the window object.
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window[windowKey] = client;
      resolve();
    });
  });
});
exports.initSplitClient = initSplitClient;
const initAvailableClients = (clients, userSplitCredentials) => __awaiter(void 0, void 0, void 0, function* () {
  const clientsStatus = {
    magento: false,
    anonymous: false
  };
  if (clients.includes(constants_1.SPLIT_TRAFFIC_TYPES.MAGENTO)) {
    // This key will be retrieved from cart request, from customerId
    const magentoKey = userSplitCredentials.splitMagentoUserKey;
    if (magentoKey) {
      yield (0, exports.initSplitClient)(constants_1.SPLIT_TRAFFIC_TYPES.MAGENTO, magentoKey);
      // We verify that the client is initialized, logs inside
      const magentoClientStatus = (0, validators_1.isSplitClientMagentoTrafficTypeInitialized)();
      clientsStatus.magento = magentoClientStatus;
    } else {
      (0, log_1.debugLog)('Could not initialize magento split client, missing magentoKey');
      (0, newrelic_1.reportNRMissingUserKey)();
    }
  }
  if (clients.includes(constants_1.SPLIT_TRAFFIC_TYPES.ANONYMOUS)) {
    const segmentUserId = (0, helpers_1.getSegmentAnonymousId)();
    const anonUserKey = (userSplitCredentials === null || userSplitCredentials === void 0 ? void 0 : userSplitCredentials.splitAnonymousUserKey) || segmentUserId;
    if (anonUserKey) {
      yield (0, exports.initSplitClient)(constants_1.SPLIT_TRAFFIC_TYPES.ANONYMOUS, anonUserKey);
      // We verify that the client is initialized, logs inside
      const anonymousClientStatus = (0, validators_1.isSplitClientAnonymousTrafficTypeInitialized)();
      clientsStatus.anonymous = anonymousClientStatus;
    } else {
      (0, log_1.debugLog)('Could not initialize anonymous split client, anonUserKey missing');
      (0, newrelic_1.reportNRMissingUserKey)();
    }
  }
  return clientsStatus;
});
exports.initAvailableClients = initAvailableClients;
const initSplit = (clientsToInitialize, userSplitCredentials) => __awaiter(void 0, void 0, void 0, function* () {
  if ((0, browser_1.isServerSideRendering)()) return (0, either_1.right)({
    magento: false,
    anonymous: false
  });
  try {
    (0, util_1.debuglog)('Initializing split io clients..');
    const clientsStatus = yield (0, exports.initAvailableClients)(clientsToInitialize, userSplitCredentials);
    (0, log_1.debugLog)('Split clients initialization finished');
    return (0, either_1.right)(clientsStatus);
  } catch (error) {
    (0, log_1.debugLog)(`Error initializing split IO client: ${JSON.stringify(error)}`);
    return (0, either_1.left)(new Error(`Error initializing split IO client: ${JSON.stringify(error)}`));
  }
});
exports.initSplit = initSplit;
// -----------------------------------------------------------------
// This will check if the Split.io client is initialized, if it is we'll update Itly context and cookie with the value returned,
// Otherwise, we'll check if the value was set as a cookie from a previous page load
// A boolean is returned based on the split or cookie, defaults to false if split is dead and no cookie was found
const splitSideEffects = (trafficType, splitName, treatment, userSplitCredentials) => {
  const isSplitReady = ![constants_1.SPLIT_IO_NOT_AVAILABLE, constants_1.SPLIT_IO_TREATMENT_CONTROL].includes(treatment);
  let splitValue = false;
  if (isSplitReady) {
    const isSplitOn = treatment === constants_1.SPLIT_IO_TREATMENT_ON;
    splitValue = isSplitOn;
    (0, browser_1.setCookie)(splitName, isSplitOn);
  } else {
    (0, newrelic_1.reportNRSplitNotReady)(trafficType, splitName, treatment, userSplitCredentials === null || userSplitCredentials === void 0 ? void 0 : userSplitCredentials.splitAnonymousUserKey, userSplitCredentials === null || userSplitCredentials === void 0 ? void 0 : userSplitCredentials.splitMagentoUserKey, userSplitCredentials === null || userSplitCredentials === void 0 ? void 0 : userSplitCredentials.splitMagentoEmail);
  }
  return splitValue;
};
exports.splitSideEffects = splitSideEffects;